import React from 'react';
import WarningModal from 'components/WarningModal/WarningModal';
import {useDeleteCampaignMutation} from 'store/slices/campaignSlice';
import {CampaignDto} from 'store/models/campaign';

interface Props {
  open: boolean;
  onClose: () => void;
  campaign: CampaignDto | null;
  onSuccess: (msg: string) => void;
}

export default function DeleteCampaignModal({
  open,
  onClose,
  campaign,
  onSuccess,
}: Props) {
  const [deleteCampaign, {isLoading}] = useDeleteCampaignMutation();

  if (!open || !campaign) return null;

  const confirm = async () => {
    await deleteCampaign({id: campaign.id}).unwrap();
    onSuccess('Campaign removed.');
    onClose();
  };

  return (
    <WarningModal
      isOpen={open}
      onClose={onClose}
      title="Remove campaign?"
      entityText={campaign.name}
      textBlocks={[`Are you sure you want to remove "${campaign.name}"?`]}
      confirmButtonText="Yes, remove"
      onConfirmButtonClick={confirm}
      loading={isLoading}
    />
  );
}
